import axios from 'axios';
import moment from 'moment-timezone';

const getPackage = async code => {
  return await axios.get(`/Packages/GetByCode/${code}`);
};

const getConfigurationClient = async () => {
  return await axios.get(`/Configurations/GetClientConfiguration`);
};

const getConfigurationTenant= async () => {
  return await axios.get(`/Configurations/GetTenantConfiguration`);
};

const isPackageExpired = (packagedata) => {
    const expirationDate = moment.utc(packagedata.ExpirationDate);
    return expirationDate.isBefore(moment(), 'day');
}

export {
  getPackage,
  getConfigurationClient,
  getConfigurationTenant,
  isPackageExpired
  //getTemplates
};